var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting_modal" }, [
    _c("div", { staticClass: "setting_modal_box" }, [
      _c("div", { staticClass: "setting_modal_box_body" }, [
        _c(
          "div",
          {
            staticClass: "setting_modal_box_close",
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  width: "12",
                  height: "12",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("g", { attrs: { fill: "#AAA", "fill-rule": "evenodd" } }, [
                  _c("path", {
                    attrs: { d: "M.255 1.545l.99-.99 9.9 9.9-.99.99z" }
                  }),
                  _c("path", {
                    attrs: { d: "M10.155.555l.99.99-9.9 9.9-.99-.99z" }
                  })
                ])
              ]
            )
          ]
        ),
        _c("p", { staticClass: "setting_modal_box_text" }, [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.screenLabelsProperties.CONFIRM_DELETE_CATEGORY_MESSAGE
              ) +
              "\n      "
          )
        ])
      ]),
      _c("div", { staticClass: "setting_modal_box_actions" }, [
        _c(
          "button",
          {
            staticClass: "setting_btn_outline",
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.screenLabelsProperties.CLOSE_MODAL) +
                "\n      "
            )
          ]
        ),
        _c(
          "button",
          {
            staticClass: "setting_btn_primary",
            on: {
              click: function($event) {
                return _vm.$emit("delete")
              }
            }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.screenLabelsProperties.CONFIRM_DELETE_BUTTON) +
                "\n      "
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }